import { availableBackScrollPath } from '~/scriptData/common/routes/backRoutes'

const backScrollPosMixin = {
  data () {
    return {
      scrollPosition: {},
      savedHeight: {},
      isPopstate: false,
      scrollHeight: 0,
      exceptionHeight: 774,
      availablePath: availableBackScrollPath
    }
  },
  watch: {
    $route: {
      handler (newValue, oldValue) {
        // 실제로 route가 변경된 경우에만 처리 (같은 페이지에서 watcher 재호출 방지)
        if (oldValue && newValue.path === oldValue.path) {
          return
        }

        if (this.$store.getters['page/getPopstate']) {
          this.isPopstate = true
          this.scrollHeight = this.scrollPosition[this.$route.path]?.height ?? 0
        } else {
          this.isPopstate = false
          if (oldValue && this.checkPath(oldValue.path)) {
            this.$set(this.scrollPosition, oldValue.path, {})
            this.$set(this.scrollPosition[oldValue.path], 'position', window.scrollY)
            this.$set(this.scrollPosition[oldValue.path], 'height', document.documentElement.scrollHeight - this.exceptionHeight)
            sessionStorage.setItem('scrollPosition', JSON.stringify(this.scrollPosition))
          }
        }
      }
    }
  },
  updated () {
    if (this.isPopstate) {
      const savedScroll = this.scrollPosition[this.$route.path]?.position ?? 0
      if (savedScroll > 0) {
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            window.scrollTo(0, savedScroll)
            this.$delete(this.scrollPosition, this.$route.path)
            sessionStorage.setItem('scrollPosition', JSON.stringify(this.scrollPosition))
            requestAnimationFrame(() => {
              this.scrollHeight = 0
            })
          })
        })
      }
    }
  },
  methods: {
    checkPath (path) {
      const lowerPath = path.toLowerCase()
      return this.availablePath.some(element =>
        lowerPath === '/ds' ? true : lowerPath.includes(element.toLowerCase())
      )
    }
  }
}

export {
  backScrollPosMixin
}
